<script setup lang="ts">
import { useMiiaFwStore } from '@/stores/miiaFwStore'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import processingImage from '@/assets/img/processing-08.gif'

/**
 * @module components/miiafw/util/MiiaFwLoading
 * @description ローディング中の画面表示を定義するモジュール。
 * @vue-data {String} [loadingImageUrl=null] ローディング中に表示するイメージのパス
 */

const loadingImageUrl = ref<string | null>(null)
const miiaFwStore = useMiiaFwStore()
const { loadingImage, loadingMessage } = storeToRefs(miiaFwStore)

if (loadingImage.value === null) {
  loadingImageUrl.value = processingImage
  miiaFwStore.updateLoadingImage(loadingImageUrl.value)
} else {
  loadingImageUrl.value = loadingImage.value
}
</script>

<template>
  <div id="miiafw-processing">
    <div
      class="miiafw-processingMessage"
      :style="{ 'background-image': 'url(' + loadingImageUrl + ')' }"
    >
      {{ loadingMessage }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
#miiafw-processing {
  display: table;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 10001;
  /* 10000以上にしないとremodalの背後になる。 */
}

#miiafw-processing .miiafw-processingMessage {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  padding-top: 140px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10002;
  /* 10000以上にしないとremodalの背後になる。 */
}
</style>
